import {useEffect, useState} from "react";

interface UseSvgLoaderReturn {
    svg: string | null;
    isLoading: boolean;
    error: Error | null;
}

const svgCache = new Map<string, string>();

export function useSvgLoader(svgPath: string): UseSvgLoaderReturn {
    const [svg, setSvg] = useState<string | null>(() => svgCache.get(svgPath) || null);
    const [isLoading, setIsLoading] = useState<boolean>(!svgCache.has(svgPath));
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        // If already in cache, use it
        if (svgCache.has(svgPath)) {
            setSvg(svgCache.get(svgPath)!);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(null);

        fetch(svgPath)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`Failed to load SVG: ${res.statusText}`);
                }
                return res.text();
            })
            .then((text) => {
                svgCache.set(svgPath, text);
                setSvg(text);
            })
            .catch((err) => {
                console.error("Failed to load SVG:", err);
                setError(err instanceof Error ? err : new Error(String(err)));
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [svgPath]);

    return {svg, isLoading, error};
}
